import React, { Component } from 'react';

import Button from '@components/button';

import './show-more.css';

export interface Props {
    text?: string;
    displayShowMore?: boolean;
    isLoading?: boolean;
    onClick(): any;
}

class ShowMore extends Component<Props> {
    public render() {
        const { displayShowMore = true, text = 'Show more', isLoading = false, onClick } = this.props;

        if (!displayShowMore) {
            return null;
        }

        return (
            <div className="show-more">
                <Button disabled={isLoading} onClick={onClick}>
                    {text}
                </Button>
            </div>
        );
    }
}

export default ShowMore;
